module.exports = __webpack_public_path__ + "static/img/fefco421_1.17ba2ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco421_1.png
// module id = qwXH
// module chunks = 0